import {
  Component,
  OnInit,
  Input,
  ViewChild,
  OnDestroy,
  ElementRef,
  ChangeDetectorRef,
} from "@angular/core";
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { LocationService } from "src/app/_services/location.service";
import * as ScanditSDK from "scandit-sdk";
import brandInfo from "../../../environments/brand.json";
import { Store } from "@ngrx/store";
import { VINDecodeCarInfoRequest } from "src/app/_models/vin-decode";
import { decodeVinGetCarInfo } from "src/app/_actions/vinDecode.actions";
import { Observable, Subscription } from "rxjs";
import {
  previewDealer,
  validateDealer,
  validateDealerSuccess,
} from "src/app/_actions/dealer-actions";
import { WrapperService } from "src/app/_services/wrapper-service.service";
import { RatesRequest } from "src/app/_models/rates";
import { loadRatesHappy } from "src/app/_actions/rates.actions";
import { guest, serviceDrive, sdLogout } from "src/app/_actions/app-flow-state.actions";
import { clear } from "src/app/_actions/modal-component.actions";
import { Router } from "@angular/router";
import { PagesService } from "src/app/_services/pages.service";
import { Dealer } from "src/app/_models/dealer";
import { showInlineLoader } from "src/app/_actions/inline-loader.actions";
import { environment } from "../../../environments/environment";
import { Vehicle } from "src/app/_models/vehicle";
import { clearCart } from "src/app/_actions/cart.actions";
import { AppConfigService } from "src/app/appconfig/appconfig.service";
import { DatePipe, DecimalPipe } from "@angular/common";
import { specialCharactersValidator } from "src/assets/customValidators/specialCharacters.validator";

@Component({
  selector: "app-service-drive",
  standalone: false,
  templateUrl: "./service-drive.component.html",
  styleUrls: ["./service-drive.component.scss"],
  providers: [DecimalPipe, DatePipe],
})
export class ServiceDriveComponent implements OnInit, OnDestroy {
  @Input() public component: any;
  screen: string;
  nextScreen: string;
  loginForm: UntypedFormGroup;
  customerForm: UntypedFormGroup;
  states: any;
  barcodeValues = [];
  loginInvalid = false;
  showCamera = false;
  bcScanner: any;
  vinDecoder$: Observable<any>;
  vinSubscription: Subscription;
  readonly = true;
  invalidVin = false;
  redirect_url: string;
  redirect_ev_url: string;
  isElectric: Boolean;
  months: any;
  days: any;
  years: any;

  scanditKey: string;
  dealerData: Dealer;
  dealerSub: Subscription;
  ratesStateSubscription: Subscription;
  getRatesPage: any;
  badDealerLogin = false;
  dealerSub$: Subscription;
  showError = false;
  thisBrand: string;
  errorMessage: number;
  branding: any;
  showISD: boolean = false;
  disableISD: boolean = false;
  serviceDriveUseISD: boolean = false;
  serviceDriveUseWarranty: boolean = false;

  constructor(
    public locationService: LocationService,
    private pageService: PagesService,
    private router: Router,
    private ratesService: WrapperService,
    private el: ElementRef,
    private store: Store<{
      vinDecode: any;
      dealer: any;
      modalComponentState: any;
    }>,
    private appConfig: AppConfigService,
    private datePipe: DatePipe,
    private decimalPipe: DecimalPipe,
    private cdr: ChangeDetectorRef
  ) {}

  get isServiceDriveRoute(): boolean {
    // This slice is intended to render only on the `/service-drive` page.
    // Some brands/pages may embed `service_drive` in other pages (e.g. `/products`),
    // but that produces confusing UX (login form on products). Guard against that.
    return (this.router?.url || "").startsWith("/service-drive");
  }

  checkForDealer() {
    let _dealer: any = JSON.parse(sessionStorage.getItem("dealer"));
    if (_dealer && _dealer.data && _dealer.data.date) {
      let expireTime = new Date(_dealer.data.date);
      expireTime.setMinutes(expireTime.getMinutes() + 15); // 15 minutes
      let currentTime = new Date();
      console.log("Expire time: ", expireTime);
      console.log("Current time: ", currentTime);
      if (expireTime >= currentTime) {
        this.readonly = false;
        _dealer.data.date = currentTime;
        this.showCamera = false;
        if (this.bcScanner) {
          this.bcScanner.destroy();
        }
        this.store.dispatch(validateDealerSuccess(_dealer));
        this.nextScreen = "CUSTOMER";
        this.loginForm.get("dealershipId").patchValue(_dealer.data.id);
        this.loginForm.get("employeeId").patchValue(_dealer.data.employeeId);
        if (
          brandInfo.brand === "Lambo" ||
          brandInfo.brand === "Hyundai" ||
          brandInfo.brand === "HPP" ||
          brandInfo.brand === "Genesis" ||
          brandInfo.brand === "BMW" ||
          brandInfo.brand === "MINI"
        ) {
          this.loginForm
            .get("employeeFirstName")
            .patchValue(_dealer.data.employeeFirstName);
          this.loginForm
            .get("employeeLastName")
            .patchValue(_dealer.data.employeeLastName);
        }
        return "CUSTOMER";
      } else {
        this.store.dispatch(validateDealerSuccess({}));
        this.store.dispatch(clearCart());
        return "LOGIN";
      }
    }
    this.store.dispatch(validateDealerSuccess({}));
    this.store.dispatch(clearCart());
    return "LOGIN";
  }

  ngOnInit() {
    if (!this.isServiceDriveRoute) {
      return;
    }
    this.thisBrand = brandInfo.brand;
    console.log("this.component.primary.redirect_link", this.component.primary.redirect_link);
    this.redirect_url = this.component.primary.redirect_link;
    this.redirect_ev_url = this.component.primary.redirect_ev_link;
    this.nextScreen = "";
    sessionStorage.removeItem("inspectionDocs"); // Reset inspection documents
    //this.store.dispatch(serviceDrive());
    
    // Preserve SDLogout state if we're in SDLogout mode
    const appFlowState = sessionStorage.getItem('appFlowState');
    if (appFlowState === 'SDLogout') {
      this.store.dispatch(sdLogout());
    }
    
    this.getRatesPage = this.pageService.getRatingPage();
    this.states = this.locationService.getStateData();
    this.detectModalComponentState();

    this.serviceDriveUseISD = brandInfo.serviceDriveUseISD;
    this.serviceDriveUseWarranty = brandInfo.serviceDriveUseWarranty;

    this.appConfig.getSettings().subscribe((result) => {
      this.branding = result;
      console.log("this.branding", this.branding);
      this.scanditKey = this.branding.scandit_license;
    });
    this.months = this.loadMonths();


    this.loginForm =
      brandInfo.brand === "Lambo" ||
      brandInfo.brand === "Porsche" ||
      brandInfo.brand === "Hyundai" ||
      brandInfo.brand === "Genesis" ||
      brandInfo.brand === "HPP" ||
      brandInfo.brand === "BMW" ||
      brandInfo.brand === "MINI"
        ? new UntypedFormGroup({
            dealershipId: new UntypedFormControl(null, [Validators.required]),
            employeeId:
              (brandInfo.brand === "Lambo" || brandInfo.brand === "Porsche")
                ? new UntypedFormControl(null, [
                    Validators.required,
                    Validators.email,
                  ])
                : new UntypedFormControl(null, [Validators.required]),
            employeeFirstName: new UntypedFormControl(null, [
              Validators.required,
              Validators.pattern("^[a-zA-Z. ]{2,30}$"),
            ]),
            employeeLastName: new UntypedFormControl(null, [
              Validators.required,
              Validators.pattern("^[a-zA-Z. ]{2,30}$"),
            ]),
          })
        : new UntypedFormGroup({
            dealershipId: new UntypedFormControl(null, [Validators.required]),
            employeeId: new UntypedFormControl(null, [Validators.required]),
          });
    this.customerForm = new UntypedFormGroup({
      vin: new UntypedFormControl(null, [
        Validators.required,
        Validators.pattern("^[a-zA-Z0-9]{0,17}$"),
        Validators.pattern("^[a-zA-Z0-9]{0,12}[0-9]{5}$"),
        Validators.pattern("^[^IOQioq ]{0,17}$"),
        specialCharactersValidator()
      ]),
      odometer: new UntypedFormControl(null, [Validators.required]),
      year: new UntypedFormControl(null, [Validators.required]),
      make: new UntypedFormControl(null, [Validators.required]),
      model: new UntypedFormControl(null, [Validators.required]),
      hasWarranty: new UntypedFormControl(null),
      isdDay:(brandInfo.brand === "Porsche" || brandInfo.brand === 'BMW' || brandInfo.brand === 'MINI' || brandInfo.brand === 'Schomp') ? new UntypedFormControl(null, [Validators.required]): new UntypedFormControl(null),
      isdMonth: (brandInfo.brand === "Porsche" || brandInfo.brand === 'BMW' || brandInfo.brand === 'MINI' || brandInfo.brand === 'Schomp') ? new UntypedFormControl(null, [Validators.required]): new UntypedFormControl(null),
      isdYear: (brandInfo.brand === "Porsche" || brandInfo.brand === 'BMW' || brandInfo.brand === 'MINI' || brandInfo.brand === 'Schomp') ? new UntypedFormControl(null, [Validators.required]): new UntypedFormControl(null)
    });
    this.screen = this.checkForDealer(); // LOGIN | CAPTURE | CUSTOMER
    //this.loadView(this.screen)
    this.vinDecoder$ = this.store.select((store) => store.vinDecode);
    this.vinSubscription = this.vinDecoder$.subscribe((vehicle) => {
      console.log("vehicle:", vehicle);
      if (vehicle && vehicle.make && vehicle.model) {
        console.log("vehicle:", vehicle);
        this.customerForm.get("make").patchValue(vehicle.make);
        this.customerForm.get("model").patchValue(vehicle.model);
        this.customerForm.get("year").patchValue(vehicle.year);

        this.disableISD = false

        this.customerForm.get("isdYear").reset(null);
        this.customerForm.get("isdMonth").reset(null);
        this.customerForm.get("isdDay").reset(null); 
        
        if((this.thisBrand === 'BMW' || this.thisBrand === 'MINI') && vehicle.inserviceDate) {
          const splitInServiceDate = vehicle.inserviceDate.split('-');
          console.log('inServiceDate', splitInServiceDate)

          // Use setTimeout to ensure form values are set after any potential form resets
          setTimeout(() => {
            // set value to customerForm when coming back from vindecoder
            this.customerForm.get("isdYear").patchValue(splitInServiceDate[0]);
            this.customerForm.get("isdMonth").patchValue(splitInServiceDate[1]);
            this.customerForm.get("isdDay").patchValue(splitInServiceDate[2]); 
            this.disableISD = true;
    
            // Force change detection to ensure template updates
            this.cdr.detectChanges();
          }, 0);
        }
 
        let _vehicle: Vehicle = JSON.parse(sessionStorage.getItem("vehicle"));
        this.isElectric = _vehicle.isElectric;

        if (
          ((brandInfo.brand.toLowerCase() === "hyundai" ||
            brandInfo.brand.toLowerCase() === "hpp" ||
            brandInfo.brand.toLowerCase() === "genesis") &&
            (vehicle.make.toLowerCase() !== "hyundai" &&
            vehicle.make.toLowerCase() !== "genesis"))
        ) {
          this.invalidVin = true;
        } else {
          this.invalidVin = false;
        }

        this.showISD = true
        this.years = this.loadYears(_vehicle.year); 
      } else {
        console.log("bad vehicle VIN ");
        this.invalidVin = true;
        this.customerForm.get("make").patchValue("");
        this.customerForm.get("model").patchValue("");
        this.customerForm.get("year").patchValue("");
      }
    });

    this.dealerSub$ = this.store
      .select((store) => store.dealer)
      .subscribe((dealer) => {
        this.dealerData = dealer;
        console.log("this.dealerData ", this.dealerData);
        if (this.dealerData && this.dealerData.success === false) {
          if (this.dealerData.type === 'preview') {
            this.loginForm.get('dealershipId').setErrors({ 'dealerNotFound': true });
          }
          this.badDealerLogin = true;
        } else {
          // Only call loadView if nextScreen is set and we're not in SDLogout state
          // In SDLogout state, we want to preserve the state and just show the LOGIN screen
          const appFlowState = sessionStorage.getItem('appFlowState');
          if (appFlowState !== 'SDLogout' || this.nextScreen !== '') {
            this.loadView(this.nextScreen);
          }
          this.badDealerLogin = false;
        }
      });

      this.days = this.loadDays();
      this.months = this.loadMonths();
  }

  ngOnDestroy(): void {
    if (this.dealerSub$) {
      this.dealerSub$.unsubscribe();
    }
    if (this.vinSubscription) {
      this.vinSubscription.unsubscribe();
    }
    if (this.ratesStateSubscription) {
      this.ratesStateSubscription.unsubscribe();
    }
    if (this.bcScanner) {
      this.bcScanner.destroy();
    }
  }

  loadYears(currentYear) {
    let years = [];
    years.push({ value: "", label: "" });
    for (let i = currentYear; i >= currentYear - 1; i--) {
      years.push({ value: i, label: i });
    }
    return years;
  }

  loadDays() {
    return [
      { value: "", label: "" },
      { value: "01", label: "01" },
      { value: "02", label: "02" },
      { value: "03", label: "03" },
      { value: "04", label: "04" },
      { value: "05", label: "05" },
      { value: "06", label: "06" },
      { value: "07", label: "07" },
      { value: "08", label: "08" },
      { value: "09", label: "09" },
      { value: "10", label: "10" },
      { value: "11", label: "11" },
      { value: "12", label: "12" },
      { value: "13", label: "13" },
      { value: "14", label: "14" },
      { value: "15", label: "15" },
      { value: "16", label: "16" },
      { value: "17", label: "17" },
      { value: "18", label: "18" },
      { value: "19", label: "19" },
      { value: "20", label: "20" },
      { value: "21", label: "21" },
      { value: "22", label: "22" },
      { value: "23", label: "23" },
      { value: "24", label: "24" },
      { value: "25", label: "25" },
      { value: "26", label: "26" },
      { value: "27", label: "27" },
      { value: "28", label: "28" },
      { value: "29", label: "29" },
      { value: "30", label: "30" },
      { value: "31", label: "31" }
    ]
  }

  loadMonths() {
    if (
      (sessionStorage.getItem("preferredLanguage")
        ? sessionStorage.getItem("preferredLanguage")
        : brandInfo.language
      ).includes("fr")
    ) {
      return [
        { value: "", label: "" },
        { value: "01", label: "janvier" },
        { value: "02", label: "février" },
        { value: "03", label: "mars" },
        { value: "04", label: "avril" },
        { value: "05", label: "mai" },
        { value: "06", label: "juin" },
        { value: "07", label: "juillet" },
        { value: "08", label: "août" },
        { value: "09", label: "septembre" },
        { value: "10", label: "octobre" },
        { value: "11", label: "novembre" },
        { value: "12", label: "décembre" },
      ];
    } else {
      return [
        { value: "", label: "" },
        { value: "01", label: "January" },
        { value: "02", label: "February" },
        { value: "03", label: "March" },
        { value: "04", label: "April" },
        { value: "05", label: "May" },
        { value: "06", label: "June" },
        { value: "07", label: "July" },
        { value: "08", label: "August" },
        { value: "09", label: "September" },
        { value: "10", label: "October" },
        { value: "11", label: "November" },
        { value: "12", label: "December" },
      ];
    }
  }

  handleBillingAddressChange(event) {
    console.log(event);
    let addressFromEvent = event.formatted_address;
    let address = addressFromEvent.split(",", 4);
    let city = address[1].trim();

    let state = address[2].trim().split(" ", 1);
    state = state[0];

    let zip = address[2].trim().split(" ");
    let length = address[2].trim().split(" ").length;
    if (length === 1) {
      zip = null;
    } else if (length === 2) {
      zip = zip[1];
    } else if (length === 3) {
      zip = zip[1] + " " + zip[2];
    }

    address = address[0].trim();

    let fullAddress = address + ", " + city + ", " + state;
    // this.userBillingAddress = fullAddress;
    this.customerForm.controls["address"].setValue(address);
    // this.customerForm.controls['address2'].setValue(address);
    this.customerForm.controls["zip"].setValue(zip);
    this.customerForm.controls["city"].setValue(city.trim());

    for (let i = 0; i < this.states.length; i++) {
      if (this.states[i].value === state) {
        return this.customerForm.controls["state"].setValue(state);
      } else {
        this.customerForm.controls["state"].reset();
        this.customerForm.controls["state"].markAsUntouched();
        this.customerForm.controls["state"].updateValueAndValidity();
      }
    }
  }

  loadView(view) {
    // LOGIN | CAPTURE | CUSTOMER
    // Check for SDLogout state first and preserve it
    const appFlowState = sessionStorage.getItem('appFlowState');
    if (appFlowState === 'SDLogout') {
      // Preserve SDLogout state - don't dispatch guest() or serviceDrive()
      if (view === "LOGIN") {
        // DEALER LOGIN VIEW - but keep SDLogout state
        this.showError = false;
        this.readonly = true;
        this.showCamera = false;
        this.badDealerLogin = false;
        if (this.bcScanner) {
          this.bcScanner.destroy();
        }
        this.store.dispatch(validateDealerSuccess({}));
        this.store.dispatch(clearCart());
        // Don't dispatch guest() - preserve SDLogout state
        this.loginForm.reset();
        this.screen = view;
        return; // Exit early to prevent other state changes
      }
    }
    
    if (view === "LOGIN") {
      // DEALER LOGIN VIEW
      this.showError = false;
      this.readonly = true;
      this.showCamera = false;
      this.badDealerLogin = false;
      if (this.bcScanner) {
        this.bcScanner.destroy();
      }
      this.store.dispatch(validateDealerSuccess({}));
      this.store.dispatch(clearCart());
      this.store.dispatch(guest());
      this.loginForm.reset();
      this.screen = view;
    }

    if (view === "CAPTURE") {
      this.store.dispatch(serviceDrive());
      // CAPTURE VIN BARCODE VIEW
      this.showError = false;
      if (this.bcScanner) {
        this.bcScanner.destroy();
      }
      this.barcodeValues = [];
      this.customerForm.reset();
      this.screen = view;
      setTimeout(() => {
        let _scandit = document.getElementById("scandit-barcode-picker");
        if (_scandit) {
          _scandit.innerHTML = "";
          ScanditSDK.configure(this.scanditKey, {
            engineLocation: "/assets",
            loadTextRecognition: true,
          })
            .then(() => {
              return ScanditSDK.BarcodePicker.create(
                document.getElementById("scandit-barcode-picker"),
                {
                  playSoundOnScan: true,
                  vibrateOnScan: true,
                }
              );
            })
            .then((barcodePicker) => {
              this.bcScanner = barcodePicker;
              const scanSettings = new ScanditSDK.ScanSettings({
                enabledSymbologies: [
                  ScanditSDK.Barcode.Symbology.CODE128,
                  ScanditSDK.Barcode.Symbology.QR,
                ],
                codeDuplicateFilter: 2000, // Minimum delay between duplicate results
                // recognitionMode: ScanditSDK.ScanSettings.RecognitionMode.TEXT, // Need a special license for OCR
                recognitionMode: ScanditSDK.ScanSettings.RecognitionMode.CODE,
              });
              this.bcScanner.applyScanSettings(scanSettings);
              this.bcScanner.on("ready", () => {
                this.showCamera = true;
              });
              // barcodePicker is ready here, show a message every time a barcode is scanned
              this.bcScanner.on("scan", (scanResult) => {
                let unique = true;
                this.barcodeValues.forEach((code) => {
                  if (code === scanResult.barcodes[0].data) {
                    unique = false;
                  }
                });
                if (unique) {
                  this.barcodeValues.push(scanResult.barcodes[0].data);
                  // console.log("TEXT: ",scanResult.texts[0].value) // OCR text -- Need a special license for OCR
                }
              });
            });
        }
      }, 1000);
    }

    if (view === "CUSTOMER") {
      // CUSTOMER LOGIN VIEW
      this.barcodeValues = [];
      this.store.dispatch(serviceDrive());
      // Reset form and clear disabled state
      this.disableISD = false;
      this.showISD = false;
      
      this.customerForm.reset();
      this.customerForm.get("hasWarranty").patchValue(false);
      
      if (this.loginForm.valid) {
        this.screen = view;
      }

      // else {
      //   this.checkForm(this.loginForm)
      // }
    }
  }

  validateDealer(view) {
    this.showError = false;
    if (this.loginForm.valid) {
      this.nextScreen = view;
      const data = this.loginForm.value;
      brandInfo.brand === "Schomp"
        ? this.store.dispatch(
            validateDealer({
              dealerId: data.dealershipId,
              customerId: data.employeeId,
            })
          )
        : this.store.dispatch(
            validateDealer({
              dealerId: data.dealershipId,
              customerId: data.employeeId,
              employeeFirstName: data.employeeFirstName,
              employeeLastName: data.employeeLastName,
            })
          );
    } else {
      this.checkForm(this.loginForm);
    }
  }

  setWarranty(hasWarranty) {
    this.customerForm.get("hasWarranty").patchValue(hasWarranty);
  }

  checkForm(form) {
    Object.keys(form.controls).forEach((field) => {
      const control = form.get(field);
      control.markAsTouched({ onlySelf: true });
    });
  }

  lookupVin(vin) {
    if(this.customerForm.controls['vin'].invalid){
      return
    }
    const vehicle: VINDecodeCarInfoRequest = {
      vin: vin,
    };
    this.store.dispatch(decodeVinGetCarInfo(vehicle));
  }

  useVIN(vin) {
    this.screen = "CUSTOMER";
    this.showCamera = false;
    this.readonly = true;
    this.bcScanner.destroy();
    this.customerForm.get("vin").patchValue(vin);
    this.customerForm.get("hasWarranty").patchValue(false);
    const vehicle: VINDecodeCarInfoRequest = {
      vin: vin,
    };
    this.store.dispatch(decodeVinGetCarInfo(vehicle));
  }

  onStarted(started) {
    console.log("started ", started);
  }

  onValueChanges(result) {
    this.barcodeValues.push(result.codeResult.code);
  }

  getRates() {
    let rateData: any;

    this.checkForm(this.customerForm);
    console.log("this.customerForm", this.customerForm.value);
    if (this.customerForm.valid && !this.invalidVin) {
      const currentCompatibleDate = this.datePipe.transform(
        new Date(),
        "yyyy-MM-dd"
      );

      console.log("this.dealerData ", this.dealerData);

      const warrantyBoolean = this.customerForm.get("hasWarranty").value;

      let request: RatesRequest = {
        brandName: brandInfo.brand,
        vin: this.customerForm.get("vin").value,
        saleDate: currentCompatibleDate,
        odometer: this.customerForm.get("odometer").value,
        inServiceDate: warrantyBoolean === true ? "" : (this.thisBrand === "Porsche" || this.thisBrand === 'BMW' || this.thisBrand === 'MINI' || this.thisBrand === 'Schomp') ? this.customerForm.get("isdYear").value + "-" + this.customerForm.get("isdMonth").value + "-" + this.customerForm.get("isdDay").value : "",
        financeType: "finance",
        isAfterSale: "false",
        vehiclePurchaseDate: currentCompatibleDate,
        vehicleCondition: "",
        customerState: this.dealerData.data.address.state,
        financeAmount: "",
        vehicleCost: "",
        vehicleMSRP: "",
        lienholderName: "",
        make: this.customerForm.get("make").value,
        model: this.customerForm.get("model").value,
        year: this.customerForm.get("year").value,
        vehicleSfId: "",
        getRatesPage: "",
        product: "VSC",
        dealer: this.dealerData.data.id,
      };

      console.log("loadNotEditedVehicle Rates:", request);

      this.store.dispatch(loadRatesHappy(request));

      this.store.dispatch(showInlineLoader());

      if (
        brandInfo.brand !== "Hyundai" &&
        brandInfo.brand !== "BMW" &&
        brandInfo.brand !== "MINI"
      ) {
        window.sessionStorage.setItem(
          "hasFactoryWarranty",
          this.customerForm.get("hasWarranty").value
        );
      }
    }
  }

  detectModalComponentState() {
    console.log("Called get rates");
    // Go to the getRatesPage Page
    this.ratesStateSubscription = this.store
      .select((store) => store.modalComponentState)
      .subscribe((ratesState) => {
        console.log("ratesState, ", ratesState);
        if (ratesState === "success") {
          this.showError = false;
          this.errorMessage = 0;
          console.log("electric", this.isElectric);
          this.store.dispatch(clear());
          if (this.redirect_ev_url && this.isElectric) {
            this.redirectTo(this.redirect_ev_url);
          } else if (this.redirect_url) {
            console.log("ray check if hit here", this.redirect_url);``
            this.redirectTo(this.redirect_url);
          } else {
            this.redirectTo(this.getRatesPage);
          }
        } else if (ratesState === "error") {
          this.showError = true;
          this.errorMessage = 2;
        } else if (ratesState === "invalidState") {
          this.showError = true;
        } else if (ratesState === "lamboNeverEligible") {
          this.showError = true;
          this.errorMessage = 2;
        } else if (ratesState === "notWithinSixtyDays") {
          this.showError = true;
          this.errorMessage = 1;
        } else if (ratesState === "productExist") {
          this.showError = true;
          this.errorMessage = 3;
        }
      });
  }

  redirectTo(url: string) {
    // Prevent this component's subscription from reacting again after we leave /service-drive
    if (this.ratesStateSubscription) {
      this.ratesStateSubscription.unsubscribe();
      this.ratesStateSubscription = null;
    }
    window.location.href = url;
  }

  getStyles(slice) {
    return {
      "background-image": "url(" + slice.primary.image.url + ")",
      "margin-top": slice.primary.margin_top
        ? slice.primary.margin_top + "px"
        : "0",
      "margin-bottom": slice.primary.margin_bottom
        ? slice.primary.margin_bottom + "px"
        : "0",
    };
  }

  onlyNumberKey(event) {
    return event.charCode == 8 || event.charCode == 0
      ? null
      : event.charCode >= 48 && event.charCode <= 57;
  }

  removeCommas() {
    const odometer = this.customerForm.controls["odometer"];
    if (odometer.value) {
      odometer.setValue(odometer.value.replace(/,/g, ""));
    }
  }

  addCommas() {
    const odometer = this.customerForm.controls["odometer"];
    if (odometer.value) {
      odometer.setValue(odometer.value.replace(/\s/g, ''));
      if (odometer.value.length === 4) {
        let beforeComma = odometer.value.substr(0, 1);
        let afterComma = odometer.value.substr(1, odometer.value.length - 1);
        odometer.setValue(beforeComma + "," + afterComma);
      } else if (odometer.value.length === 5) {
        let beforeComma = odometer.value.substr(0, 2);
        let afterComma = odometer.value.substr(2, odometer.value.length - 1);
        odometer.setValue(beforeComma + "," + afterComma);
      } else if (odometer.value.length === 6) {
        let beforeComma = odometer.value.substr(0, 3);
        let afterComma = odometer.value.substr(3, odometer.value.length - 1);
        odometer.setValue(beforeComma + "," + afterComma);
      } else if (odometer.value.length > 6) {
        odometer.setValue("999,999");
      }
    }
  }

  previewDealer() {
    const dealershipId = this.loginForm.get('dealershipId')?.value?.trim?.() ?? this.loginForm.get('dealershipId')?.value;
    if (dealershipId) {
      this.store.dispatch(previewDealer({ dealershipId }));
    }
  }
}
